var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noteTitle"},[(_vm.titleShow&&_vm.title!='')?_c('span',{staticStyle:{"color":"#97a8be"}},[_vm._v("《"+_vm._s(_vm.title)+"》")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }